import { ALL_PACKAGES_GET, ALL_PACKAGES_GET_ERROR, ALL_PACKAGES_GET_SUCCESS, CHECKUP_PAYMENTS, CHECKUP_PAYMENTS_ERROR, CHECKUP_PAYMENTS_SUCCESS, CHECKUPS_HEALTH_RECORD_REQUEST, CHECKUPS_HEALTH_RECORD_REQUEST_ERROR, CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS, CHECKUPS_RECORD_IMAGE_OPEN, CHECKUPS_RECORD_IMAGE_OPEN_ERROR, CHECKUPS_RECORD_IMAGE_OPEN_SUCCESS, MY_CHECKUPS_GET, MY_CHECKUPS_GET_ERROR, MY_CHECKUPS_GET_SUCCESS, PACKAGE_DETAILS_ID, PROMTION_PACKAGES_GET, PROMTION_PACKAGES_GET_ERROR, PROMTION_PACKAGES_GET_SUCCESS, SELECTED_CHECKUP_TABLE } from './Constants';

export const checkupListRequest = () => ({
    type: MY_CHECKUPS_GET,
});

export const checkupListSuccessRequest = (data) => ({
    type: MY_CHECKUPS_GET_SUCCESS,
    payload : data
});

export const checkupListErrorRequest = () => ({
    type: MY_CHECKUPS_GET_ERROR,
});

export const selectedCheckupTable = (data) => ({
    type: SELECTED_CHECKUP_TABLE,
    payload : data
});


export const healthRecordRequest = (checkupId) => ({
    type: CHECKUPS_HEALTH_RECORD_REQUEST,
    checkupId : checkupId
});

export const healthRecordRequestSuccess = (payload) => ({
    type: CHECKUPS_HEALTH_RECORD_REQUEST_SUCCESS,
    payload : payload,
});

export const healthRecordRequestError = () => ({
    type: CHECKUPS_HEALTH_RECORD_REQUEST_ERROR,
});

export const healthRecordImageRequest = (url) => ({
    type: CHECKUPS_RECORD_IMAGE_OPEN,
    url : url
});

export const healthRecordImageRequestSuccess = (payload) => ({
    type: CHECKUPS_RECORD_IMAGE_OPEN_SUCCESS,
    payload : payload
});

export const healthRecordImageRequestError = () => ({
    type: CHECKUPS_RECORD_IMAGE_OPEN_ERROR,
});

export const packageListRequest = (orgId, page) => ({
    type: ALL_PACKAGES_GET,
    orgId : orgId,
    page: page
});

export const packageListSuccessRequest = (data) => ({
    type: ALL_PACKAGES_GET_SUCCESS,
    payload : data
});

export const packageListErrorRequest = () => ({
    type: ALL_PACKAGES_GET_ERROR,
});

export const packageClickedIdRequest = (packageId) => ({
    type: PACKAGE_DETAILS_ID,
    packageId : packageId
});

export const checkupPaymentsRequest = (payload) => ({
    type: CHECKUP_PAYMENTS,
    payload : payload
});

export const checkupPaymentsSuccessRequest = (successMsg) => ({
    type: CHECKUP_PAYMENTS_SUCCESS,
    successMsg : successMsg
});

export const checkupPaymentsErrorRequest = () => ({
    type: CHECKUP_PAYMENTS_ERROR,
});

export const promotionsRequest = () => ({
    type: PROMTION_PACKAGES_GET
});

export const promotionsSuccessRequest = (data) => ({
    type: PROMTION_PACKAGES_GET_SUCCESS,
    payload : data
});

export const promotionsErrorRequest = () => ({
    type: PROMTION_PACKAGES_GET_ERROR,
});
